var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navigation__item account-btn border--mobile-none" },
    [
      _c(
        "a",
        {
          staticClass: "navigation__item__button ml-2 mr-0 d-inline-block",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.showAccount.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "22",
                height: "24",
                viewBox: "0 0 22 24",
              },
            },
            [
              _c("g", [
                _c("g", [
                  _c("g", [
                    _c("path", {
                      attrs: {
                        fill: "none",
                        stroke: "#444",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-miterlimit": "20",
                        "stroke-width": "1.4",
                        d: "M11 12v0a5 5 0 0 1-5-5V6a5 5 0 0 1 10 0v1a5 5 0 0 1-5 5z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      attrs: {
                        fill: "none",
                        stroke: "#444",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-miterlimit": "20",
                        "stroke-width": "1.4",
                        d: "M21 20.908a3.99 3.99 0 0 0-2.934-3.856C16.172 16.535 13.586 16 11 16c-2.586 0-5.172.535-7.066 1.052A3.99 3.99 0 0 0 1 20.908V23h20v0-2.092 0z",
                      },
                    }),
                  ]),
                ]),
              ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "account-btn__box",
          class: { "account-btn__box--visible": _vm.isVisibleSearcher },
        },
        [
          _c("ul", { staticClass: "account-btn__box__list" }, [
            _c("li", [
              _c(
                "a",
                {
                  staticClass:
                    "font__family--gotham font__weight--light font__color--gray",
                  attrs: { href: _vm.account },
                },
                [_vm._t("my-account")],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.is_logged_in
              ? _c("li", [
                  _c(
                    "a",
                    {
                      staticClass:
                        "font__family--gotham font__weight--light font__color--gray link-is-hovered",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.logout.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._t("logout")],
                    2
                  ),
                ])
              : _vm._e(),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }